import Provider from "./Provider";
import Tab from "./Tab";
import Panel from "./Panel";
import TabList from "./TabList";

export default { Provider, Tab, TabList, Panel };
